/**
 * ============================================================================
 * LANGUAGE SWITCHER COMPONENT
 * ============================================================================
 * 
 * Bilingual language switcher for Cameroon (French/English)
 */

import React from 'react';
import { useI18n } from '../../providers';

/**
 * Language Switcher Component
 * @returns {JSX.Element}
 */
const LanguageSwitcher = () => {
  const { language, setLocale } = useI18n();

  const toggleLanguage = () => {
    setLocale(language === 'fr' ? 'en' : 'fr');
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-4 py-2 rounded-xl bg-white/80 dark:bg-gray-800/80 backdrop-blur-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-200 shadow-sm hover:shadow-md"
      aria-label={language === 'fr' ? 'Switch to English' : 'Passer au français'}
    >
      <span className="text-lg">
        {language === 'fr' ? '🇫🇷' : '🇬🇧'}
      </span>
      <span className="font-medium text-gray-700 dark:text-gray-300">
        {language === 'fr' ? 'FR' : 'EN'}
      </span>
      <svg
        className="w-4 h-4 text-gray-500 dark:text-gray-400"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M8 7l4-4 4 4m0 6l-4 4-4-4"
        />
      </svg>
    </button>
  );
};

export default LanguageSwitcher;
